import styled, { css } from 'styled-components';
import { accentGreen, playGrey20 } from '../../../design-tokens';

export const ProgressBar = styled.span`
    height: 4px;
    display: block;
    position: relative;
    ${(props) =>
        props.percent === 0 &&
        css`
            display: none;
        `}
    ${(props) =>
        props.hidden &&
        css`
            visibility: hidden;
        `}

    ${(props) =>
        props.withBackground &&
        css`
            background-color: ${playGrey20};
        `}
`;

export const ProgressValue = styled.div`
    background-color: ${accentGreen};
    height: 100%;
    ${(props) => css`
        width: ${props.percent}%;
    `}
`;
